import React from 'react'
import logoImage from '../images/kmart_flat_masterbrand_rgb.png'

const Homepage = () => {
    return (
        <footer>
            <div className="footer-brand">
                <div className="footer-brand__content">
                    <div className="svg-logo">
                        <a href="/" title="kmart">
                        <span className="icon-kmart_logo_white">
                          <img src={logoImage} alt="Return to Kmart Home" />
                        </span>
                        </a>
                    </div>
                    <div className="copy-rights">
                        <p className="special-size">
                        <span className="special-font" style={{fontSize: '0.75rem'}}>
                          Copyright Kmart&nbsp;
                          <span id="year">2022</span>
                        </span>
                        </p>
                    </div>
                </div>
            </div>
            <div className="band-grad"></div>
        </footer>
    )
}

export default Homepage